import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';

export const sentryLogger = {
  /** Logs custom error that should be reported. Do not use it for 400 errors or similar */
  logError: (err: Error) => {
    if (sentryLogger.shouldLogAsFailedRequest(err)) {
      return;
    }

    Sentry.captureException(err);
  },

  /** Helper for processing request errors. It will analyze request and decide if it should be reported */
  logFailedRequest: (resp: AxiosError) => {
    if (!resp) {
      return;
    }

    if (sentryLogger.shouldLogAsFailedRequest(resp)) {
      const statusCode = resp.response?.status || parseInt(resp.code || '');
      const url = resp.response?.config.url || 'Unknown';

      Sentry.withScope((scope) => {
        if (resp.config.headers) {
          scope.setTags({
            status: statusCode,
            requestId: resp.config.headers['X-Request-Id'] || '',
            sessionId: resp.config.headers['X-Session-Id'] || '',
          });

          if (resp.response?.data) {
            scope.setContext('Response', { response: JSON.stringify(resp.response.data) });
          }

          resp.name = `API Error (${statusCode}) - ${url}`;
          Sentry.captureException(resp);
        }
      });
    }
  },

  shouldLogAsFailedRequest: (err: any): boolean => {
    if (!!err.isAxiosError) {
      const statusCode = err.response?.status || parseInt(err.code || '');
      return statusCode >= 500 || statusCode === 404 || statusCode === 400;
    }
    return false;
  },
};
